/*global $*/
/*eslint no-undef: "error"*/
export default class Prop {
    classItem = 'prop--item'
    classBlock = 'prop--block'
    classButton = 'prop--button'

    classBlockHidden = 'prop-blocks__block-hidden'
    classButtonGray = 'button-gray'
    classButtonGrayLight = 'button-gray-light'

    constructor () {
        let self = this

        $(`.${self.classButton}`).click(function () {
            let block = $(this).data('block')

            $(this).closest(`.${self.classItem}`).find(`.${self.classButton}`).removeClass(self.classButtonGray).addClass(self.classButtonGrayLight)
            $(this).removeClass(self.classButtonGrayLight).addClass(self.classButtonGray).removeClass(self.classButtonGrayLight)

            $(this).closest(`.${self.classItem}`).find(`.${self.classBlock}`).addClass(self.classBlockHidden)
            $(this).closest(`.${self.classItem}`).find(`.${self.classBlock}[data-block='${block}']`).removeClass(self.classBlockHidden)

            console.log(block)
        })
    }
}
